import { Ring } from '@uiball/loaders'


function Loader() {
  return (
    <div>
        <Ring 
        size={40}
        lineWeight={5}
        speed={2} 
        color="black"
        />
  </div>
  )
}

export default Loader